import { debounce } from 'lodash';
import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormInstancesByProject } from 'api/form';
import { ReactComponent as FormInstanceIcon } from 'assets/svgs/form-instance-icon.svg';
import { Input } from 'components/atoms/input';
import { Empty } from 'components/organisms/projects/project-sidebar/spaces-menu/styles';
import { useTranslate } from 'hooks/use-translation';
import { ListItem } from './listItem';
import {
  GroupTitle,
  Menu,
  MenuContainer,
  MenuGroupItem,
  SearchContainer,
  SidebarWrapper,
} from './sider.styles';

type FormSiderPropTypes = {
  projectFormInstance: FormInstancesByProject;
  activeKey: number;
};

export const FormSider = ({
  projectFormInstance: { projectId, instances = [] },
  activeKey,
}: FormSiderPropTypes) => {
  const translate = useTranslate();
  const [searchInput, setSearchInput] = useState<string>();

  const onSearch = (e: string) => {
    setSearchInput(e?.trim());
  };

  const debouncedonSearch = useMemo(() => debounce(onSearch, 500), []);

  const filteredFormInstances = instances.filter((formInstance) =>
    formInstance.taskName
      .toLowerCase()
      .includes((searchInput ?? '').toLowerCase()),
  );

  return (
    <SidebarWrapper>
      <SearchContainer>
        <Input
          allowClear
          size="small"
          placeholder={translate('projects.form_responses.search.text')}
          onChange={(e) => debouncedonSearch(e.target.value)}
        />
      </SearchContainer>

      <MenuContainer>
        <Menu mode="inline" defaultSelectedKeys={[activeKey.toString()]}>
          <MenuGroupItem
            title={
              <GroupTitle ellipsis={{ tooltip: true }}>
                {translate('forms')}
              </GroupTitle>
            }
          />

          {filteredFormInstances.length ? (
            filteredFormInstances.map(({ taskName, formInstanceId }) => {
              return (
                <Menu.Item icon={<FormInstanceIcon />}>
                  <ListItem
                    projectId={projectId}
                    formInstanceId={formInstanceId}
                    taskName={taskName}
                  />
                </Menu.Item>
              );
            })
          ) : (
            <Empty ellipsis>
              <FormattedMessage id="projects.spaces.search.empty_text" />
            </Empty>
          )}
        </Menu>
      </MenuContainer>
    </SidebarWrapper>
  );
};
